import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'DemoDialog-dialog',
  templateUrl: './DemoDialog.component.html',
  styleUrls: ['./DemoDialog.component.scss'],
})
export class DemoDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DemoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }
}
